// @packages
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';

// @script
import CtrlAccordion from '../ctrl-accordion';
import { config } from '../../../../config';

// @styles
import styles from './styles';

const CtrlAccordionSearch = ({
    classes,
    className,
    id,
    onChangeIncludeDriveLoss,
    onClickDriveLossMode,
    onFieldBlur,
    onFieldChange,
    onEnterClick,
    searchInputs,
    state
}) => {
    const accordionSearchClass = classNames(
        className,
        classes.accordionSearch
    );

    return (
        <div id={id} className={accordionSearchClass}>
            {
                searchInputs.map((searchInput) => (
                    <CtrlAccordion
                        defaultExpanded={searchInput.defaultExpanded}
                        fields={searchInput.fields}
                        id={`${id}-${searchInput.name}`}
                        key={searchInput.name}
                        name={searchInput.name}
                        onChangeIncludeDriveLoss={onChangeIncludeDriveLoss}
                        onClickDriveLossMode={onClickDriveLossMode}
                        onFieldBlur={onFieldBlur}
                        onFieldChange={onFieldChange}
                        onEnterClick={onEnterClick}
                        state={state}
                        text={config.text.searchInput}
                    />
                ))
            }
        </div>
    );
};

CtrlAccordionSearch.propTypes = {
    className: PropTypes.string,
    classes: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    onChangeIncludeDriveLoss: PropTypes.func,
    onClickDriveLossMode: PropTypes.func,
    onFieldBlur: PropTypes.func.isRequired,
    onFieldChange: PropTypes.func.isRequired,
    onEnterClick: PropTypes.func,
    searchInputs: PropTypes.arrayOf(PropTypes.shape({
        fields: PropTypes.array.isRequired,
        name: PropTypes.string.isRequired
    })).isRequired,
    state: PropTypes.object.isRequired
};

CtrlAccordionSearch.defaultProps = {
    className: null,
    onChangeIncludeDriveLoss: null,
    onClickDriveLossMode: null,
    onEnterClick: null
};

export default withStyles(styles)(CtrlAccordionSearch);
